import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import ElementoForm from "../../../components/forms/ElementoForm.vue";
import { ElementoService } from "../../../services/ElementoService";

export default {
    name: "EditarElemento",
    components: {
        Breadcrumb,
        ElementoForm
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Configuração',
                disabled: false,
                href: '/gerenciar-elementos',
            },
            {
                text: 'Editar Elemento',
                disabled: true
            }
        ],
        elementoData: null
    }),
    created() {
        this.carregarElemento(this.$route.params.id);
    },
    methods: {
        async carregarElemento(id) {
            try {
                const response = await ElementoService.show(id);

                if (response) {
                    const data = response.data;
                    
                    // Mapear dados da API para o formato esperado pelo ElementoForm
                    this.elementoData = {
                        id: data.id,
                        exercicio: data.exercicio, // Passa o objeto exercicio completo
                        codigo_elemento: data.codigo_elemento || '',
                        descricao: data.descricao || '',
                        ativo: data.ativo !== undefined ? Boolean(data.ativo) : true
                    };
                    
                } 
            } catch (error) {
                console.error('Ocorreu um erro ao carregar os dados do Elemento:', error);
                this.$globalAlert('Erro ao carregar dados do elemento');
            }
        },
        
        async handleSave(formData) {
            try {
                
                // Verificação de segurança - garantir que todos os campos obrigatórios estejam preenchidos
                if (!formData.exercicio || !formData.codigoElemento || !formData.descricao) {
                    console.error('Campos obrigatórios não preenchidos:', {
                        exercicio: formData.exercicio,
                        codigoElemento: formData.codigoElemento,
                        descricao: formData.descricao
                    });

                    return;
                }
                
                const dataToSend = new FormData();
                dataToSend.append("exercicio", formData.exercicio);
                dataToSend.append("codigo_elemento", formData.codigoElemento); // Usar codigoElemento do formData
                dataToSend.append("descricao", formData.descricao);
                dataToSend.append("ativo", formData.ativo ? 1 : 0);

                const response = await ElementoService.update(this.$route.params.id, dataToSend);

                if (response) {
                    this.$router.push('/gerenciar-elementos');
                } 
            } catch (error) {
                console.error('Erro ao salvar elemento:', error);
                this.$globalAlert('Erro ao atualizar elemento. Tente novamente.');
            }
        },
        
        handleCancel() {
            this.$router.push('/gerenciar-elementos');
        }
    }
};
